import AppConstants from '../config/app.constants';

let CarrierService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/carrier`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/carrier/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id) => {
        return $http
            .delete(AppConstants.api + `/carrier/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/carrier/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/carrier/${id}`)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        update,
        get
    };
};

CarrierService.$inject = ['$http', '$q']

export default CarrierService;


// WEBPACK FOOTER //
// ./client/app/services/carrier.service.js